import React from 'react';

interface SwitchProps {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  color?: 'primary' | 'secondary' | 'default';
  size?: 'small' | 'medium';
  className?: string;
}

const Switch: React.FC<SwitchProps> = ({
  checked = false,
  onChange,
  disabled = false,
  color = 'primary',
  size = 'medium',
  className = '',
}) => {
  const sizeClasses = {
    small: 'w-8 h-4',
    medium: 'w-11 h-6',
  };

  const colorClasses = {
    primary: checked ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600',
    secondary: checked ? 'bg-gray-600' : 'bg-gray-300 dark:bg-gray-600',
    default: checked ? 'bg-gray-600' : 'bg-gray-300 dark:bg-gray-600',
  };

  return (
    <label className={`relative inline-flex items-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only peer"
      />
      <div className={`${sizeClasses[size]} ${colorClasses[color]} peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:after:h-5 peer-checked:after:w-5`} />
    </label>
  );
};

export default Switch;

